import React from 'react';

// "Include deactivated" switch shown on every patient list. Lists are active-only by default.
const IncludeDeactivatedToggle = ({ checked, onChange, id = 'includeDeactivated' }) => (
    <div className="form-check form-switch mt-2" style={{ whiteSpace: 'nowrap' }}>
        <input className="form-check-input" type="checkbox" id={id} checked={!!checked}
            onChange={e => onChange(e.target.checked)} />
        <label className="form-check-label" htmlFor={id} style={{ fontSize: '13px' }}>Include deactivated</label>
    </div>
);

export default IncludeDeactivatedToggle;
